import actions from '../../actionTypes';

export default (siteId, areas) => {
  return {
    type: actions.SET_AREAS,
    siteId,
    areas
  };
};



// WEBPACK FOOTER //
// ./src/reducers/areas/actions/setAreas.js